import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_PHASE4 = createFcmDetails('starter_experience_dashboard_phase4', {
	owner: 'Axolotl Squad',
	context: 'Starter Dashboard',
	description: 'Controls the visibility of the Starter Experience Dashboard Phase 4 features.',
	import: false,
	template: {
		experimentName: 'starter_experience_dashboard_phase4_experiment',
		enabled: false,
	},
});
